import React, { useState } from "react";

import { IDepartmentTree } from "redux/reducers/models/product";
import Drawer from "components/drawerSlide/drawer";
import { useTranslation } from "react-i18next";
import Input from "components/form/input/Input";
import DepartmentFilterSection from "./Department/DepartmentFilterSection";
import Divider from "components/divider";
import Checkbox from "components/form/checkbox/Checkbox";

interface IDrawerProps {
  onSelect?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClose?: () => void;
  onClear?: () => void;
  onOk?: () => void;
  isOpen: boolean;
  filterTitle?: string;
  subtitle?: string;
  departmentTree?: IDepartmentTree[];
  deptIds?: number[];
  children?: React.ReactNode;
  statusFilterTitle?: string;
  statusSelections?: Record<string, boolean>;
  onFlatToggle?: (filterCategory: string, status: string, checked: boolean) => void;
}

export default function FilterDrawer(props: IDrawerProps) {
  const { t } = useTranslation();
  const [searchFilter, setSearchFilter] = useState<string>("");

  function handleSearchInput(e: React.ChangeEvent<HTMLInputElement>) {
    const { value } = e.target;
    setSearchFilter(value);
  }

  return (
    <Drawer
      open={props.isOpen}
      title={t("Filters")}
      subtitle={props.subtitle ?? t("Apply department, category and subcategory filters to view reports.")}
      onClose={props.onClose}
      onOk={props.onOk}
      okText={t("Run")}
      cancelButtonType="secondary"
      secondaryActions={[{ label: t("Clear all"), action: () => props.onClear(), buttonType: "secondary" }]}
      backDropClose
    >
      {props.children ? <div className="p-4">{props.children}</div> : null}

      {/* Department Logic */}
      {props.departmentTree ? (
        <div className="p-4">
          <Input
            placeholder={t("Search by department, category, etc...")}
            value={searchFilter}
            onChange={e => handleSearchInput(e)}
            labelHidden
          />
          <h3 className="pt-4">{props.filterTitle}</h3>

          <div className="pt-4">
            {props?.departmentTree
              ? props?.departmentTree.map((branch, branchIndex) => {
                  return (
                    <DepartmentFilterSection
                      search={searchFilter}
                      onSelect={props.onSelect}
                      key={branchIndex}
                      section={branch}
                      deptIds={props.deptIds}
                    />
                  );
                })
              : null}
          </div>
        </div>
      ) : null}

      {/* Status Selection -> Transition to a component? */}
      {props.statusSelections ? (
        <>
          {props?.departmentTree ? <Divider /> : null}
          <div className="p-4">
            <h2 className="pb-2">{props.statusFilterTitle ? props.statusFilterTitle : t("Status Filters")}</h2>
            {Object.entries(props.statusSelections)?.map(([status, checked]) => {
              return (
                <div key={status} className="pt-1">
                  <Checkbox
                    size={"medium"}
                    key={status}
                    id={status}
                    checked={checked}
                    onChange={e => props.onFlatToggle("status", status, e.target.checked)}
                    label={status.charAt(0).toUpperCase() + status.slice(1)}
                  />
                </div>
              );
            })}
          </div>
          <div className="m-1">
            <Divider />
          </div>
        </>
      ) : null}
    </Drawer>
  );
}
